import React from "react";
import styled from "styled-components";
import {BorderGradient} from "../../styles/globalStyles";
import {device} from "../../styles/breakpoints";


const Wrapper = styled(BorderGradient)`
  margin-top: 5vh;
  width: 90%;
  height: 250px;
  border-radius: 30px;
`;
const Padding = styled.div`
  height: 100%;
  border-radius: 30px;
  padding: 1vh 5vw;
  background-image: linear-gradient(to right, rgba(0, 240, 255, 15%), rgba(255, 0, 122, 15%));
  @media ${device.tablet} {
    padding: 0.1vh 0.5vw;
  }


`;
const Paragraph = styled.p`
  font-size: 15px;
  width: 80%;
  @media ${device.desktop} {
    font-size: 15px;
  }
`;

const Image = styled.span`
  background-image: url(${({img}) => img});
  background-position: center;
  background-size: cover;
  width: 50px;
  height: 50px;
  display: block;
  grid-row: 1/-1;
  align-self: center;
`;

const PersonDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-template-rows: repeat(2,30px);
`;

const H3 = styled.h3`
  margin: 0;
  align-self: center;

`;

const StyledWorkplaceText = styled.p`
  margin: 0;
  font-size: 15px;
`;



const CustomerCard = ({children, img, name, workplace}) => (
  <Wrapper>
    <Padding>
      <Paragraph>{children}</Paragraph>
      <PersonDetails>
        <Image img={img}/>
        <H3>{name}</H3>
        <StyledWorkplaceText>{workplace}</StyledWorkplaceText>
      </PersonDetails>
    </Padding>
  </Wrapper>
);
export default CustomerCard;


